import useCredentialSharingNag from 'hooks/useCredentialSharingNag'
import React, { useState } from 'react'
import CredentialSharingNagBanner from './CredentialSharingNagBanner'
import CredentialSharingNagModal from './CredentialSharingNagModal'

const CredentialSharingNagGuard = () => {
  const nag = useCredentialSharingNag()
  // Lets a merchant who dismissed the modal re-open it from the banner even
  // though the once-per-day dismissal cookie keeps `showModal` false.
  const [manuallyOpened, setManuallyOpened] = useState(false)

  if (!nag.show) return null

  const close = () => setManuallyOpened(false)

  return (
    <>
      <CredentialSharingNagBanner onReview={() => setManuallyOpened(true)} />
      <CredentialSharingNagModal
        isOpen={nag.showModal || manuallyOpened}
        authority={nag.authority}
        obligations={nag.obligations}
        onDismiss={() => {
          close()
          nag.dismiss()
        }}
        onGrantAuthority={() => {
          close()
          nag.handleGrantAuthority()
        }}
        onManageOnApple={nag.handleManageOnApple}
        onDeclineAuthority={nag.handleDecline}
        onReconsider={nag.handleReconsider}
      />
    </>
  )
}

export default CredentialSharingNagGuard
